import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { GlobalSearchRequestModel } from '../core/models/global-search-request.model';
import { GlobalSearchResponseModel } from '../core/models/global-search-response.model';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  private readonly apiUrl = `${environment.baseUrl}/GlobalSearch`;

  constructor(private http: HttpClient) {}

  search(request: GlobalSearchRequestModel): Observable<GlobalSearchResponseModel> {
    const params = new HttpParams()
      .set('query', request.query)
      .set('page', request.page.toString())
      .set('pageSize', request.pageSize.toString());

    return this.http.get<GlobalSearchResponseModel>(`${this.apiUrl}/search`, { params });
  }

  searchWithDefaults(query: string, page: number = 1, pageSize: number = 20): Observable<GlobalSearchResponseModel> {
    const request: GlobalSearchRequestModel = {
      query,
      page,
      pageSize
    };

    return this.search(request);
  }
}
